import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var fontFamily = "TrustpilotDefaultFont, Helvetica Neue, Helvetica, Arial, sans-serif";
var weights = {
  normal: 400,
  medium: 500,
  bold: 700
};
var body2 = {
  fontFamily: fontFamily,
  fontSize: "14px",
  lineHeight: "20px",
  fontWeight: weights.normal,
  letterSpacing: "0.3px"
};
export default {
  family: fontFamily,
  weights: weights,
  "display-1": {
    fontFamily: fontFamily,
    fontSize: "32px",
    lineHeight: "40px",
    fontWeight: weights.bold
  },
  "display-2": {
    fontFamily: fontFamily,
    fontSize: "24px",
    lineHeight: "32px",
    fontWeight: weights.bold
  },
  "heading-1": {
    fontFamily: fontFamily,
    fontSize: "18px",
    lineHeight: "28px",
    fontWeight: weights.bold
  },
  "heading-2": {
    fontFamily: fontFamily,
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: weights.medium
  },
  "body-1": {
    fontFamily: fontFamily,
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: weights.normal,
    letterSpacing: "0.3px"
  },
  "body-2": body2,
  label: _objectSpread(_objectSpread({}, body2), {}, {
    fontWeight: weights.medium
  })
};